import React, { useEffect, useContext } from 'react';
import AnswerButton from '../Buttons/AnswerButton';
import { useCounter } from '../../Handler/CounterHandler';
import useDocTitle from '../../Handler/DocTitleHandler';
import { AppContext } from '../../DataProviders/AppStateProvider';
import RenderCondition from '../RenderCondition';
import Text from '../Text';

/**
 * Arthur-Fischer-Erfinderpreis Quick Check App
 *
 * Step C
 *
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const StepBewerber = props => {
  // Use the context for global data storage and state management
  const { appData } = useContext(AppContext);
  const { setDocTitle } = useDocTitle();
  const { counterCurrent, counterTotal } = useCounter();

  // Changes the doc title
  useEffect(() => {
    setDocTitle(`Schritt ${counterCurrent}/${counterTotal}`);
  }, [counterCurrent]);

  const isPrivatePersonJourney = appData.currentJourney === 'privatePerson';

  return (<>
    <div className="text text--small text--afp-quickcheck text--counter">{counterCurrent} / {counterTotal}</div>

    <h2 className="headline headline--2">Ich bin...</h2>

    <div className="text text--afp-quickcheck">
      <RenderCondition condition={!isPrivatePersonJourney}>
        <Text path="steps.bewerber.textStudent">Meine / Unsere Schule ist in Baden-Württemberg.</Text>
      </RenderCondition>

      <RenderCondition condition={isPrivatePersonJourney}>
        <Text path="steps.bewerber.textPrivate">Ich bin eine Privatperson, die ihren Wohnsitz oder ihren Arbeitsplatz in Baden-Württemberg hat.</Text>
      </RenderCondition>
    </div>

    <div className="container__afp-quickcheck-answers">
      <AnswerButton answer={true}>Ja</AnswerButton>
      <AnswerButton answer={false} nextStep={'result'}>Nein</AnswerButton>
      {/* <AnswerButton answer={false} nextStep={'result'}>Nein</AnswerButton> */}
    </div>

    <RenderCondition condition={isPrivatePersonJourney}>
      <div className="text text--small text--afp-quickcheck">
        <Text path="steps.bewerber.textPrivateHint">Hinweis: Betriebsinhaber, die Schutzrechte auf ihren eigenen Namen angemeldet haben,
        werden nicht als private Erfinder gesehen, wenn die zugrundeliegende Erfindung in den
        Geschäftsbereich ihres Unternehmens fallen. Bei Erfindungen von Arbeitnehmern muss der
          Arbeitgeber die Erfindung freigegeben haben (§ 8 ArbnErfG).</Text>
      </div>
    </RenderCondition>
  </>);
}

export default StepBewerber;
